var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"4","offset":"4"}},[_c('agrega-referencia-form-component',{attrs:{"id":_vm.id}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }